/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

const CardTitle = ({title, ...props}) => {
    return (
      <div
        css={css`
            grid-area: title;
            font-size: 1.3rem;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.87);
            text-align: center;
            text-transform: lowercase;
            
            &::first-letter {
                text-transform: uppercase;
            }
        `}
        className={props.className}
      >
          {title}
      </div>

    )
}

export { CardTitle }
